module.exports = __webpack_public_path__ + "img/si_iphonexspacegrey_portrait.8934de34.png";